import { type MutationOptions, useMutation } from 'react-query'

import agent from 'agent'
import useAuth from 'hooks/use-auth'
import { integrationClientsMutationKeys } from 'queries/integration-clients/query-keys'
import { getEndpointWithParams } from 'queries/queries-utils'

function deleteIntegrationClient([endpoint, params]: ReturnType<
  typeof integrationClientsMutationKeys.delete
>) {
  return async () => {
    const endpointWithParams = getEndpointWithParams(endpoint, params)

    await agent.delete(endpointWithParams)
  }
}

export const useDeleteIntegrationClients = (
  identifier: string,
  options?: Omit<MutationOptions, 'mutationKey' | 'mutationFn'>
) => {
  const { currentTeamId: teamId } = useAuth()

  const queryParams = {
    identifier,
    teamId
  }

  const mutationKey = integrationClientsMutationKeys.delete(queryParams)

  return useMutation({
    ...options,
    mutationKey,
    mutationFn: deleteIntegrationClient(mutationKey)
  })
}
